import { EGetNotificationsListActionTypes, TGetNotificationsListFailed } from './types';
import { actionGenerator } from '../../../utils/redux/actionGenerator';

export const getNotificationsListFailed: () => TGetNotificationsListFailed =
  actionGenerator<EGetNotificationsListActionTypes.Failed>(EGetNotificationsListActionTypes.Failed);
